import { useEffect, useRef, type RefObject } from 'react';

/**
 * Keeps a ref pointing at the latest value while never changing identity itself.
 *
 * Use it when a callback has to reach a value that changes often, but must not take that value as a
 * dependency — a `useCallback` that depends on something unstable is recreated constantly, and any
 * effect depending on that callback re-runs just as often. Where the effect also triggers the very
 * change it depends on, that becomes an infinite loop.
 */
export function useLatestRef<T>(value: T): RefObject<T> {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
